/**
 * `X-Vendor-Organization` header — vendor-admin masquerading. SMS-only by
 * default; AIM/Beacon/One leave the accessor unset and the hook is a no-op.
 *
 * Lifted from `apps/aegix-sms-react/src/lib/api-client.ts` (`ACTIVE_ORG_KEY`
 * read path). The accessor returns the active organization id (string|number)
 * or null. Returning null skips header injection — it does not clear an
 * already-set header.
 */
import type { BeforeRequestHook } from 'ky';

export type VendorOrgAccessor = () => string | number | null | undefined;

export function vendorOrgBeforeRequest(
  accessor: VendorOrgAccessor,
): BeforeRequestHook {
  return ({ request }) => {
    try {
      const id = accessor();
      if (id !== null && id !== undefined && id !== '') {
        request.headers.set('X-Vendor-Organization', String(id));
      }
    } catch {
      // Accessor faulted (storage parse error, etc.) — skip rather than
      // block the request. Mirrors SMS's existing try/catch around its
      // localStorage parse path.
    }
  };
}
